import { useEffect } from 'react';

import { setRumPage, type SetRumPageProps } from '../lib/rum';

/**
 * Включает отправку Rum метрик для просматриваемой страницы, дополняя их мета-информацией о странице.
 *
 * Хук предназначен для использования в корневом компоненте на каждой странице сервиса.
 *
 * @kind helper
 * @param pageName - Имя просматриваемой страницы.
 * @returns {void}
 **/
export function useRumPage({ pageName }: SetRumPageProps) {
    useEffect(() => {
        setRumPage({ pageName });
    }, [pageName]);
}
